import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ProductCatalogComponent } from './pages/product-catalog/product-catalog.component';
import { TaxTablesComponent } from './pages/tax-tables/tax-tables.component';
import { SupplierComponent } from './pages/supplier/supplier.component';



import { TabsComponent } from './components/tabs/tabs.component';
import { TooltipsComponent } from './components/tooltips/tooltips.component';

import { PagesLoginComponent } from './pages/pages-login/pages-login.component';

import { MangeClientsComponent } from './pages/mange-clients/mange-clients.component';

import { TierWalletComponent } from './components/tier-wallet/tier-wallet.component';
import { ManageBrokersComponent } from './components/manage-brokers/manage-brokers.component';
import { BrokerDetailsComponent } from './components/brokerDetails/brokerDetails.component';
import { ManageClientsComponent } from './components/manage-clients/manage-clients.component';
import { ManageCustomersComponent } from './components/manage-customers/manage-customers.component';
import { EditAdvisorComponent } from './components/edit-advisor/edit-advisor.component'
import { AddbrokerDetailsComponent } from './components/addbrokerDetails/addbrokerDetails.component'
import { AuthGuardService } from './services/authGuard.service'
import { ReportsComponent } from './components/reports/reports.component'
import { EmployeePortalComponent } from './components/employee-portal/employee-portal.component'
import { MyplansComponent } from './components/myplans/myplans.component'
import { ManageSystemUsersComponent } from './components/manage-system-users/manage-system-users.component'
import { InvoicesComponent } from './components/invoices/invoices.component'
import { EditCorporateComponent } from './components/edit-corporate/edit-corporate.component'
import { PayablesComponent } from './components/payables/payables.component'
import { MarketingComponent } from './components/marketing/marketing.component'
import { SettingsComponent } from './components/settings/settings.component'
import { ViewCustomersComponent } from './components/viewCustomers/viewCustomers.component'
import { ViewCustomerDetailsComponent } from './components/view-customer-details/view-customer-details.component'
import { OverviewComponent } from './components/overview/overview.component'
import { AddCustomerComponent } from './components/add-customer/add-customer.component'
import { AddEmployeeComponent } from './components/add-employee/add-employee.component'
import { CorporateDashboardComponent } from './components/corporate-dashboard/corporate-dashboard.component';
import { CreateEmployeeComponent } from './components/create-employee/create-employee.component';
import { AdvisorDashboardComponent } from './components/advisor-dashboard/advisor-dashboard.component';
import { PlansDetailsComponent } from './components/plans-details/plans-details.component';
import { environment } from 'src/environments/environment';
import { ReportDetailComponent } from './components/reports/report-detail/report-detail.component';
import { TravelCommissionsComponent } from './components/travel-commissions/travel-commissions.component';
import { ReportsScheduleComponent } from './components/reports-schedule/reports-schedule.component';
import { PaymentPdsComponent } from './components/payment-pds/payment-pds.component';
import { InvoiceDataComponent } from './components/invoice-data/invoice-data.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { ManageCustomersNewComponent } from './components/manage-customers-new/manage-customers-new.component';
import { ManageBrokersNewComponent } from './components/manage-brokers-new/manage-brokers-new.component';
import { ManageClientsNewComponent } from './components/manage-clients-new/manage-clients-new.component';
import { ManageCustomersDatatableComponent } from './components/manage-customers-datatable/manage-customers-datatable.component';
import { ProvisioningComponent } from './components/provisioning/provisioning.component';
import { BrouchersComponent } from './components/brouchers/brouchers.component'
import { GigToCorpComponent } from './components/gig-to-corp/gig-to-corp.component';
import { PaymentComponent } from './payment/payment.component';
import { AddTierComponent } from './components/add-tier/add-tier.component';
import { CommonPlansComponent } from './app/common-plans/common-plans.component';
import { AdjudicationQueueComponent } from './components/adjudication-queue/adjudication-queue.component';
import { PagesLoginWithTokenComponent } from './pages/pages-login-with-token-component/pages-login-with-token-component.component';
import { ReceivablesComponent } from './receivables/receivables.component';
import { PayableComponent } from './payable/payable.component';
import { CreateSupplierComponent } from './components/create-supplier/create-supplier.component';

const routes: Routes = [
  { path: '', component: PagesLoginComponent },
  { path: 'loginWithToken', component: PagesLoginWithTokenComponent },
  { path: 'login', component: PagesLoginComponent },
  // { path: 'inprogress', component: CommonComponent, canActivate: [AuthGuardService] },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'product-catalog', component: ProductCatalogComponent },
  { path: 'tax-tables', component: TaxTablesComponent },
  { path: 'supplier', component: SupplierComponent },
  { path: 'supplier/create-supplier', component: CreateSupplierComponent },
   { path: 'supplier/update-supplier', component: CreateSupplierComponent },


  { path: 'myplans', component: MyplansComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageUsers', component: ManageSystemUsersComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageCorporates/addCorporate', component: MangeClientsComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageCorporates/addCorporate/tiers', component: TierWalletComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageCorporates/edit-corporate/tiers', component: TierWalletComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'addTier', component: AddTierComponent, canActivate: [AuthGuardService], pathMatch: 'full' },




  // { path: 'manageAdvisors', component: ManageBrokersComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  // { path: 'manageCorporates', component: ManageClientsComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  // { path: 'manageMembers', component: ManageCustomersComponent, canActivate: [AuthGuardService], pathMatch: 'full' },

  { path: 'manageAdvisors', component: ManageBrokersNewComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageCorporates', component: ManageClientsNewComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageMembers', component: ManageCustomersDatatableComponent, canActivate: [AuthGuardService], pathMatch: 'full' },

  { path: 'manageDetails/:id', component: BrokerDetailsComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageAdvisors/editAdvisor/:id', component: EditAdvisorComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageAdvisors/:id/viewAdvisor', component: AdvisorDashboardComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageAdvisors/advsiors/:id/customers', component: ViewCustomersComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageCorporates/:id/view', component: CorporateDashboardComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageCorporates/:id/viewEmployees', component: CreateEmployeeComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageCorporates/:id/viewPlans', component: PlansDetailsComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageMembers/employee/:id/details', component: OverviewComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageCorporates/edit-corporate/:id', component: EditCorporateComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'customer/:id/details', component: ViewCustomerDetailsComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageAdvisors/addAdvisor', component: AddbrokerDetailsComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageMembers/addMember', component: AddCustomerComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'manageCorporates/addEmployee', component: AddEmployeeComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'reports', component: ReportsComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'report-detail', component: ReportDetailComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'employee-portal', component: EmployeePortalComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  // { path: 'invoices', component: InvoicesComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'invoices', component: InvoiceDataComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'invoices/:invoiceNumber', component: InvoiceDataComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'receivables',component:ReceivablesComponent, canActivate: [AuthGuardService], pathMatch: 'full'},
  { path: 'payable',component:PayableComponent, canActivate: [AuthGuardService], pathMatch: 'full'},
  { path: 'payables', component: PayablesComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  // { path: 'marketing&promotions', component: MarketingComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  // { path: 'brochures', component: MarketingComponent, canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'brochures', component: BrouchersComponent, canActivate: [AuthGuardService], pathMatch: 'full' },



  { path: 'settings', component: SettingsComponent, canActivate: [AuthGuardService], pathMatch: 'full' },

  { path: 'underwriting-queue', component: AdjudicationQueueComponent, canActivate: [AuthGuardService], pathMatch: 'full' },




  { path: 'tabs', component: TabsComponent },
  { path: 'tooltips', component: TooltipsComponent },

  { path: 'login', component: PagesLoginComponent },
  { path: 'signin', component: PagesLoginComponent },
  { path: 'plans', component: CommonPlansComponent },

  { path: 'travel-commissions', component: TravelCommissionsComponent },
  { path: 'reports-schedule', component: ReportsScheduleComponent },
  { path: 'payments', component: PaymentsComponent },
  { path: 'provisioning', component: ProvisioningComponent },
  { path: 'gig-to-corp/:id', component: GigToCorpComponent },
  { path: 'payment', component: PaymentComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
